import React, { useState, useEffect } from "react";
import "../assets/styles/auth.css";
import RegistraionField from "../components/RegistrationField";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function ForgetPassword() {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
        document.title = "DCode | Forget password";
      }, []);

  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  const showMessage = (text) => {
    setMessage(text);
    setTimeout(() => setMessage(""), 5000);
  };

  const showError = (text) => {
    setError(text);
    setTimeout(() => setError(""), 5000);
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post(`${BACKEND_URL}/auth/send-otp/`, { email });
      showMessage(res.data.message); // e.g., "OTP sent to your email"
      setStep(2);
      setResendTimer(30);
    } catch (err) {
      showError(err.response?.data?.error || "Failed to send OTP");
    }
  };

  const handleResendOtp = async () => {
    try {
      const res = await axios.post(`${BACKEND_URL}/auth/send-otp/`, { email });
      showMessage("OTP resent to your email.");
      setResendTimer(30);
    } catch (err) {
      showError(err.response?.data?.error || "Failed to resend OTP");
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (otp.length !== 5) {
      showError("OTP must be 5 digits.");
      return;
    }

    try {
      const res = await axios.post(`${BACKEND_URL}/auth/verify-otp/`, {
        email,
        otp
      });
      showMessage(res.data.message || "OTP verified");
      setStep(3);
    } catch (err) {
      showError(err.response?.data?.error || "Invalid OTP");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      showError("Passwords do not match.");
      return;
    }

    try {
      const res = await axios.post(`${BACKEND_URL}/auth/reset-password/`, {
        email,
        new_password: newPassword,
        confirm_password: confirmPassword
      });
      showMessage(res.data.message || "Password reset successful! Redirecting...");
      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    } catch (err) {
      showError(err.response?.data?.error || "Failed to reset password");
    }
  };

  return (
    <>
      <Navbar />

      <section id="login">
        <div className="login-container" data-aos="flip-left">
          <h2 className="form-title">
            {step === 1 && "Reset your password"}
            {step === 2 && "Enter OTP"}
            {step === 3 && "Enter new password"}
          </h2>

          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}

          {step === 1 && (
            <form onSubmit={handleSendEmail} className="login-form">
              <RegistraionField
                type="email"
                placeholder="Email address"
                icon="mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit" className="login-button forget-btn">Send OTP</button>
            </form>
          )}

          {step === 2 && (
            <form onSubmit={handleVerifyOtp} className="login-form otp-form fade-in">
              <div className="otp-inputs">
                {[0, 1, 2, 3, 4].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    className="otp-box"
                    value={otp[index] || ""}
                    onChange={(e) => {
                      const newOtp = otp.split("");
                      newOtp[index] = e.target.value.replace(/\D/, "");
                      setOtp(newOtp.join(""));
                      if (e.target.value && index < 4) {
                        document.getElementById(`otp-${index + 1}`)?.focus();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !otp[index] && index > 0) {
                        document.getElementById(`otp-${index - 1}`)?.focus();
                      }
                    }}
                    id={`otp-${index}`}
                  />
                ))}
              </div>

              <button type="submit" className="login-button forget-btn">Verify OTP</button>
              <button
                type="button"
                className="resend-btn ms-auto"
                onClick={handleResendOtp}
                disabled={resendTimer > 0}
              >
                {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : "Resend OTP"}
              </button>
            </form>
          )}

          {step === 3 && (
            <form onSubmit={handleResetPassword} className="login-form fade-in">
              <RegistraionField
                type="password"
                placeholder="Password"
                icon="lock"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <RegistraionField
                type="password"
                placeholder="Confirm Password"
                icon="lock"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button type="submit" className="login-button forget-btn">Reset Password</button>
            </form>
          )}

          <p className="signup-prompt">
            Don't have an account? <a href="/signup" className="signup-link">Sign up</a>
          </p>
        </div>

        <Footer />
      </section>
    </>
  );
}

export default ForgetPassword;
